// @flow
import type { ProviderUtms } from '../../../components/ProviderUtmPage'

type State = {|
  utmType: 'ort' | 'provider',
  providerUtms: ProviderUtms,
  ortUtm: string,
  updateType: 'none' | 'active' | 'all',
  isLoading: boolean
|}

type InitAction = {|
  +type: 'PROVIDER_UTM_PAGE.INIT',
  +state: State
|}

type PatchAction = {|
  +type: 'PROVIDER_UTM_PAGE.PATCH',
  +state: $Shape<State>
|}

type Action = PatchAction | InitAction

export type { State }

const initialProviderUtms: ProviderUtms = {
  vk: '',
  target_mail: '',
  facebook: '',
  instagram: '',
  google: ''
}

const initialState: State = {
  utmType: 'ort',
  providerUtms: initialProviderUtms,
  ortUtm: '',
  updateType: 'none',
  isLoading: false
}

export function patch(diff: $Shape<State>): Action {
  return {
    type: 'PROVIDER_UTM_PAGE.PATCH',
    state: diff
  }
}

export function init(state: State): Action {
  return {
    type: 'PROVIDER_UTM_PAGE.INIT',
    state
  }
}

function fromInitial(initial: State): State {
  return {
    utmType: initial.utmType || 'ort',
    providerUtms: initial.providerUtms || initialProviderUtms,
    ortUtm: initial.ortUtm || '',
    updateType: initial.updateType || 'none',
    isLoading: false
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'PROVIDER_UTM_PAGE.INIT':
      return fromInitial(action.state)
    case 'PROVIDER_UTM_PAGE.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
